import React from 'react';
import { Grid, FormControl, FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import { hobbiesOptions } from './constant';
import FormLabelWithIcon from './FormLabelWithIcon';

export const HobbiesPicker = ({
  intl, options, onValueChange,
  field = 'hobbies',
  classes = {}, required = false,
  name = 'clients-hobbies',
  label = 'clients-hobbies'
}) => {
  const selected = options[field] || [];

  const handleChange = (value, checked) => {
    const newSelected = checked
      ? [...selected, value]
      : selected.filter(item => item !== value);
    onValueChange(field, newSelected, selected);
  };

  return (
    <Grid className={classes?.sectionContainer || ''}>
      <FormLabelWithIcon
        iconName="Compass"
        labelText={intl.formatMessage({ id: label })}
        type="blue"
        required={required}
      />
      <FormControl>
        <FormGroup row aria-label={label}>
          {hobbiesOptions.map(({ value, labelId }) => (
            <FormControlLabel
              key={value}
              control={
                <Checkbox
                  className={classes.checkboxOption}
                  color="default"
                  checked={selected.includes(value)}
                  onChange={event => handleChange(value, event.target.checked)}
                  style={{
                    color: selected.includes(value) ? '#3966f8' : 'rgba(0, 0, 0, 0.54)',
                    paddingTop: '2px',
                    paddingBottom: '2px'
                  }}
                />
              }
              label={intl.formatMessage({ id: labelId })}
            />
          ))}
        </FormGroup>
      </FormControl>
    </Grid>
  );
};
